export default "__VITE_ASSET__CqfRDEYY__"